import { render } from "./Pagine.vue?vue&type=template&id=7a311606"
import script from "./Pagine.vue?vue&type=script&lang=js"
export * from "./Pagine.vue?vue&type=script&lang=js"
script.render = render

export default script